export default {
  data() {
    return {};
  },
  props: {
    rtilCode: {
      type: Number,
      default: 0
    }
  }
};